const open = "data-open";
const closed = "data-closed";
const anchorHidden = "data-anchor-hidden";
export {
  anchorHidden,
  closed,
  open
};
//# sourceMappingURL=CommonPopupDataAttributes.js.map
